import { gql } from '@apollo/client';

const SEND_SUPPLIER_MESSAGE = gql`mutation sendSupplierMEssage($supplierOrderId: Int!, $message: String) {
	incomingOrders {
		sendMessageToOrderer(supplierOrderId: $supplierOrderId, message: $message)
	}
}`;

export default SEND_SUPPLIER_MESSAGE;